import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import PanesHeader from 'modules/core/components/PanesHeader'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import { useGroups } from 'modules/reviews/hooks/useGroups'
import { useReviewsSplitViewData } from 'modules/reviews/lib/useReviewsSplitData'
import { useQuestionGroups } from 'modules/reviews/pages/performance/ReviewsReviewee/useQuestionGroups'

import Table from './Table'

interface Props {
  reviewId: number
  employeeId: number
  isAnonymous: boolean
}

export default function Content({ reviewId, employeeId, isAnonymous }: Props) {
  useGroups()
  const { navigation } = useNavigation()

  const employee = employees.get(employeeId)
  const user = employee && employeeUser(employee)
  const userId = user?.attributes.id
  const { loading, questionGroups } = useQuestionGroups(reviewId, userId!)
  const splitViewData = useReviewsSplitViewData(questionGroups)

  if (!user) throw new Error(`Cannot find user with id: ${userId}`)

  if (loading) return <Loading />

  return (
    <Box gap="s32">
      <Box flexDirection="column" gap="s32">
        <PanesHeader
          separation={false}
          illustration="surveys"
          title={i18n.t('surveys.review.reviews.reviewee.title', {
            user: user.preferredName,
          })}
          description={i18n.t('surveys.review.reviews.reviewee.description')}
        />
        {splitViewData.canSeeSplitView &&
          splitViewData.selfQuestionGroupId &&
          splitViewData.managerQuestionGroupId && (
            <Button.Router
              to={navigation.employees.id.reviews.answer.splitView.fullPath({
                id: employeeId,
                review_id: reviewId,
              })}
              iconName="more-options"
            >
              {i18n.t('surveys.review.reviews.split_view.button')}
            </Button.Router>
          )}
      </Box>
      <Box>
        <Table
          formId={reviewId}
          isAnonymous={isAnonymous}
          questionGroups={questionGroups}
          employeeId={employeeId}
        />
      </Box>
    </Box>
  )
}
